<template>
  <div class="post-main">
    <el-table ref="refTable"  @row-click="expandRow" style="width: 100%" :data="data" :row-class-name="rowClassName">
      <el-table-column type="expand" >
        <template slot-scope="{row}">
          <el-form label-position="left"  label-width="110px" class="demo-table-expand" style="margin-left: 10px">
            <el-form-item   label="发布时间" >
              {{ row.create_time|parseTime}}
            </el-form-item>
            <el-form-item style="margin-top: -20px" label="浏览" >
              {{ row.read_sum }}
            </el-form-item>
            <el-form-item style="margin-top: -20px" label="留言" >
              {{ row.comment_sum }}
            </el-form-item>
            <el-form-item style="margin-top: -20px" label="标题" >
              {{ row.title }}
            </el-form-item>
            <el-form-item style="margin-top: -20px" label="正文" >
              <div v-html="row.content">
              </div>
            </el-form-item>
            <el-form-item style="margin-top: -20px;" label="附件" >
              <div class="post-main-images">
                <div :class="'post-main-word'" :key="x.id" v-for="x in row.Attachments">
                  <ul @click="previewWord(x)" class="el-upload-list el-upload-list--text">
                    <li tabindex="0" class="el-upload-list__item is-success">
                      <a class="el-upload-list__item-name">
                        <i class="el-icon-document"></i>
                        {{x.name}}
                  </a>
                    </li>
                  </ul>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="发布时间"  width="180px" prop="time">
        <template slot-scope="{row}">
          {{ row.created_at|parseTime}}
        </template>
      </el-table-column>
<!--      <el-table-column label="发布类型" show-overflow-tooltip  prop="title"></el-table-column>-->
<!--      <el-table-column label="部门"  width="80px" prop="doSearch">-->
<!--        <template slot-scope="{row}">-->
<!--          {{ row.like_sum }}-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="标题"  width="290px" show-overflow-tooltip prop="title">
        <template slot-scope="{row}">
          {{row.title}}
        </template>
      </el-table-column>
<!--      <el-table-column label="正文"  width="80px" prop="doSearch">-->
<!--        <template slot-scope="{row}">-->
<!--          {{ row.share_sum }}-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="附件"  width="100px" prop="doSearch">
        <template slot-scope="{row}">
          {{ row.Attachments.length }}
        </template>
      </el-table-column>
      <el-table-column label="浏览"  width="100px" prop="doSearch">
        <template slot-scope="{row}">
          {{ row.read_sum }}
        </template>
      </el-table-column>
      <el-table-column label="留言"  width="100px" prop="doSearch">
        <template slot-scope="{row}">
          <el-button icon="el-icon-s-comment" @click="handleShowComment(row)" size="mini" type="warning" plain></el-button>
        </template>
      </el-table-column>
      <el-table-column  width="125px" label="操作">
        <template slot-scope="{row}">
          <axj-button-v2
            button-color="bread"
            button-size="medium"
            button-icon="del1"
            @click="handleDelete(row.id)"
          ></axj-button-v2>
          <axj-button-v2
            @click="handleUpdate(row.id)"
            button-icon="edit1"
          ></axj-button-v2>
        </template>
      </el-table-column>
    </el-table>
    <axj-file-preview
      :show-preview.sync="preview.show"
      :preview-file-type="preview.previewFileType"
      :preview-files="preview.previewFiles"
    />
    <comment
      :show.sync="comment.show"
      :post-type="comment.postType"
      :post-id="comment.postId"
    />
  </div>
</template>
<script>
import AxjButtonV2 from "../../../../../components/common/button/axj-button";
import AxjButton from "../../../../../components/axj-button/index";
import commonModels from '@/common/models/common-models'
import common from '@/common/common'
import AxjFilePreview from "../../../../../components/axj-file-preview/index";
import Comment from "../../action/component/comment";
export default {
  name: "school-post-main",
  components: {Comment, AxjFilePreview, AxjButtonV2, AxjButton},
  props:{
    data:{
      type:Array,
      default:()=>{
        return []
      }
    }
  },
  watch:{
    data(v){

    }
  },
  methods:{
    handleDelete(id){
      this.$emit("delete",id)
    },
    handleShowComment(row){
      this.comment.postId=row.id
      this.comment.show=true
    },
    handlePlayVideo(row) {
      if(row.video_url) {
        let url = row.video_url.indexOf('http')>=0?row.video_url:this.resourcePrefix.url+row.video_url
        this.video.url = url
        this.showLovePlayer = true
      }
    },
    handleUpdate(v){
      this.$emit('update',v)
    },
    expandRow(row,index,e){
      let target=e.target
      console.log(target)
      if(target.className.indexOf('cell')==0||target.className.indexOf('el-tag')==0||target.className.indexOf('el-table')==0){
        this.$refs.refTable.toggleRowExpansion(row)
        return
      }
    },
    previewWord(x){
      this.preview.previewFileType=x.type
      this.preview.previewFiles=[]
      this.preview.previewFiles.push({
        url:x.url
      })
      this.preview.show=true
    },
    rowClassName({row, rowIndex}){
      row.index=rowIndex
      if(rowIndex%2==0){
        return "while-row"
      }else{
        return "gray-row"
      }    }
  },
  computed:{
    preViewUrl(){
      return this.$common.SystemConfig.PreViewUrl
    }
  },
  filters:{
    parseTime(time){
      return commonModels.formatTime(time,'Y/M/D h:m:s')
    },
    arrayImg(v,x){
      let preViewUrl=common.SystemConfig.PreViewUrl
      let array=[]
      for (let i =0 ;i<v.length;i++){
       if(v[i].type=='image'){
         array.push(preViewUrl+v[i].url)
         // if(v[i].url==x.url){
         //   let temp=array[0]
         //   array[0]=preViewUrl+x.url
         //   array.push(temp)
         // }else{
         //
         // }
       }
      }
      return array
    }
  },
  data(){
    return{
      comment:{
        show:false,
        postType:'school',
        postId:1
      },
      showLovePlayer: false,
      video: {
        url : '',
      },
      preview:{
        show:false,
        previewFileType:'word',
        previewFiles:[]
      }
    }
  }
}
</script>

<style scoped lang="scss">
.post-main{
  .el-tag,.el-tag--info {
    background-color: #41555d;
    /* border-color: #e9e9eb; */
    color: #ffffff;
  }
  .el-table__body tr:hover>td{
    background-color: #f2f5f8 !important;
  }
  .el-table__body tr.current-row>td{
    background-color: #f2f5f8 !important;
  }
  .post-main-content{
    line-height: 20px;
    margin-top: 9px;
  }
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .while-row {
    background: #ffffff;
  }
  .el-table .gray-row {
    background: #e8eef0;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-table .info-row{
    background: #D6D8DC;
  }

  .post-main-images{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .post-main-dio{
      width: 126.888px;
      height: 126.888px;
      border-radius: 10px;
      margin-top: 18.26px;
      img{
        width: 100%;
        height: 100%;
        width: 126.888px;
        height: 126.888px;
        border-radius: 10px;
      }
    }
    .post-main-word{
      width: 426.888px;
      height: 26.888px;
      border-radius: 10px;
      margin-top: 18.26px;
    }
    .post-main-image{
      width: 126.888px;
      height: 126.888px;
      border-radius: 10px;
      margin-top: 18.26px;
      .el-image{
        width: 100%;
        height: 100%;
        width: 126.888px;
        height: 126.888px;
        border-radius: 10px;
      }
      img{
        width: 100%;
        height: 100%;
        width: 126.888px;
        height: 126.888px;
        cursor: pointer;
      }
    }
    .post-main-image:not(:first-child){
      margin-left: 30.5px;
    }
    .post-main-image:nth-child(5n+6){
      margin-left: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-post/component/school-post-main/index.vue